// 重新导出类型和API
export * from './types'

// API调用方法
import service from './request'
import type {
    LoginParams,
    LoginResponse,
    UserInfo,
    DashboardStats,
    TrendData,
    DistributionData,
    AIFunction,
    AIFunctionRequest,
    StatusUpdateRequest,
    PageResponse,
    AIModelDetail
} from './types'
const prefix = '/admin-api'
// ======================== 认证相关 API ========================
export const authApi = {
    /**
     * 管理员登录
     */
    login: (data: LoginParams): Promise<LoginResponse> => {
        return service.post(prefix + '/v1/auth/login', data)
    },

    /**
     * 管理员登出
     */
    logout: (): Promise<void> => {
        return service.post(prefix + '/v1/auth/logout')
    },

    /**
     * 获取当前登录管理员信息
     */
    getUserInfo: (): Promise<UserInfo> => {
        return service.get(prefix + '/v1/auth/userinfo')
    }
}

// ======================== 仪表盘相关 API ========================
export const dashboardApi = {
    /**
     * 获取仪表盘统计数据
     */
    getStats: (): Promise<DashboardStats> => {
        return service.get(prefix + '/v1/dashboard/stats')
    },

    /**
     * 获取使用趋势数据
     * @param days 天数，默认7天
     */
    getTrendData: (days: number = 7): Promise<TrendData[]> => {
        return service.get(prefix + '/v1/dashboard/trend', {
            params: { days }
        })
    },

    /**
     * 获取功能调用分布数据
     */
    getDistributionData: (): Promise<DistributionData[]> => {
        return service.get(prefix + '/v1/dashboard/distribution')
    }
}

// ======================== AI功能管理相关 API ========================
export const aiFunctionApi = {
    /**
     * 获取AI功能列表（分页）
     */
    getList: (params: AIFunctionRequest): Promise<PageResponse<AIFunction>> => {
        return service.get(prefix + '/v1/ai-functions', { params })
    },

    /**
     * 根据ID获取AI功能详情
     */
    getById: (id: number): Promise<AIFunction> => {
        return service.get(`${prefix}/v1/ai-functions/${id}`)
    },

    /**
     * 创建AI功能
     */
    create: (data: AIFunction): Promise<string> => {
        return service.post(prefix + '/v1/ai-functions', data)
    },

    /**
     * 更新AI功能
     */
    update: (id: number, data: AIFunction): Promise<string> => {
        return service.put(`${prefix}/v1/ai-functions/${id}`, data)
    },

    /**
     * 删除AI功能
     */
    delete: (id: number): Promise<string> => {
        return service.delete(`${prefix}/v1/ai-functions/${id}`)
    },

    /**
     * 切换AI功能状态
     */
    toggleStatus: (id: number, data: StatusUpdateRequest): Promise<string> => {
        return service.patch(`${prefix}/v1/ai-functions/${id}/status`, data)
    },

    /**
     * 获取功能分类列表
     */
    getCategories: (): Promise<string[]> => {
        return service.get(prefix + '/v1/ai-functions/categories')
    }
}

// ======================== AI模型详情相关 API ========================
export const aiModelApi = {
    /**
     * 获取AI模型详情
     */
    getDetail: (id: number): Promise<AIModelDetail> => {
        return service.get(`${prefix}/v1/ai-models/${id}`)
    },

    /**
     * 获取AI模型列表（支持分页和筛选）
     */
    getList: (params?: any): Promise<AIModelDetail[] | { data: AIModelDetail[], total: number }> => {
        return service.get(prefix + '/v1/ai-models', { params })
    },

    /**
     * 获取所有分类列表
     */
    getCategories: (): Promise<string[]> => {
        return service.get(prefix + '/v1/ai-models/categories')
    },

    /**
     * 更新AI模型信息
     */
    update: (id: number, data: AIModelDetail): Promise<string> => {
        return service.put(`${prefix}/v1/ai-models/${id}`, data)
    },

    /**
     * 创建AI模型
     */
    create: (data: AIModelDetail): Promise<number> => {
        return service.post(prefix + '/v1/ai-models', data)
    },

    /**
     * 删除AI模型
     */
    delete: (id: number): Promise<string> => {
        return service.delete(`${prefix}/v1/ai-models/${id}`)
    },

    /**
     * 切换AI模型状态
     */
    toggleStatus: (id: number, status: number): Promise<string> => {
        return service.patch(`${prefix}/v1/ai-models/${id}/status`, { status })
    }
}

// 统一导出所有API
export const api = {
    auth: authApi,
    dashboard: dashboardApi,
    aiFunction: aiFunctionApi,
    aiModel: aiModelApi
}

export default api